import ShareableFilesSelectModal from './ShareableFilesSelectModal.component';

export default ShareableFilesSelectModal;
